import React from 'react';
import SideMenu from '../Menu/SideMenu';
import TopBar from '../TopBar/TopBar';
import './Layout.css';
import { Outlet } from 'react-router-dom';

export default function LayoutPrefeitura() {
  return (
    <div className="layout-container">
      <TopBar />
      <SideMenu onClose={() => {}} />
      <div className="layout-content">
        <Outlet />
      </div>
    </div>
  );
} 